import React from 'react'
import styled from 'styled-components'
import { inboxSkeletonSurface } from '../skeleton/inboxSkeletonStyles'

interface MessagePreloaderProps {
    sent?: boolean
    bubbleWidth?: number
}

const MessagePreloader: React.FC<MessagePreloaderProps> = ({ sent, bubbleWidth = 120 }) => (
    <Container sent={sent}>
        <Bubble sent={sent} $width={bubbleWidth} />
        <Meta />
    </Container>
)

const Container = styled.div<{ sent?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: ${props => props.sent ? 'flex-end' : 'flex-start'};
    margin-bottom: 12px;
    flex-shrink: 0;
`
const Bubble = styled.div<{ sent?: boolean; $width: number }>`
    width: ${props => props.$width}px;
    height: 40px;
    border-radius: 24px;
    ${inboxSkeletonSurface}
`
const Meta = styled.div`
    width: 120px;
    height: 12px;
    margin-top: 6px;
    border-radius: 4px;
    ${inboxSkeletonSurface}
`

export default MessagePreloader
